import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface SmartVotingConfig {
  enabled: boolean;
}

export const useSmartVoting = () => {
  const [config, setConfig] = useState<SmartVotingConfig>({
    enabled: false,
  });
  const [loading, setLoading] = useState(true);
  const [isFeatureEnabled, setIsFeatureEnabled] = useState(false);

  // Load system configuration
  const loadConfig = useCallback(async () => {
    try {
      const { data, error } = await supabase
        .from('admin_settings')
        .select('setting_value')
        .eq('setting_key', 'smart_voting_features')
        .single();

      if (error) {
        console.error('Error loading Smart Voting Features config:', error);
        return;
      }

      if (data?.setting_value) {
        const configValue = data.setting_value as any;
        const newConfig = {
          enabled: configValue.enabled ?? false,
        };
        setConfig(newConfig);
        setIsFeatureEnabled(newConfig.enabled);
      }
    } catch (error) {
      console.error('Error loading config:', error);
    }
  }, []);

  // Initialize data
  useEffect(() => {
    const init = async () => {
      setLoading(true);
      await loadConfig();
      setLoading(false);
    };
    init();
  }, [loadConfig]);

  return {
    isFeatureEnabled,
    config,
    loading,
    refreshConfig: loadConfig,
  };
};